/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-11-28",
    versionChannel: "nightly",
    buildDate: "2023-11-28T00:15:02.160Z",
    commitHash: "4805a07301d3ddb86f9e57e619643bb8c723e6a9",
};
